<template>
    <div class="college-major">
       
           <el-table
              ref="dragTable"
              :data="list"
              border
              fit
              highlight-current-row
              row-key="date"
            max-height="600"
            element-loading-background="rgba(255, 255, 255, 0.2)"
            >
        
            <el-table-column label="添加" width="50 "  prop="Id" v-if="iszntb">
                <template slot-scope="scope">
                    <div class="flex zhong center"><input type="checkbox" name="add" v-model="scope.row.selected" v-if="scope.row.IsOptional" /></div>
                </template>
            </el-table-column>
            <!-- <el-table-column v-if="tableType === 1" width="60" type="index"></el-table-column> -->

            <el-table-column :label="columnName.RateStr || '录取概率'" width="60">
                <template slot-scope="scope">
                    <div>
                        <p v-if="scope.row.Remarks == '新增'">新增</p>
                        <p v-else>{{ scope.row.Rate }}</p>
                        <!-- <p>{{scope.row.Remarks}}</p> -->
                    </div>
                </template>
            </el-table-column>

            <el-table-column :label="columnName.PositionStr || '志愿位置'" width="60">
                <template slot-scope="scope">
                    <div>
                        <p style="color: #fa4237;" v-if="scope.row.Position === '冲'">冲</p>
                        <p style="color: #f3af3b;" v-else-if="scope.row.Position === '稳'">稳</p>
                        <p style="color: #42ab3f;" v-else-if="scope.row.Position === '保'">保</p>
                    </div>
                </template>
            </el-table-column>
            <el-table-column :label="columnName.CollegesNameStr || '院校名称'" width="182">
                <template slot-scope="scope">
                    <div class="name_div ">
                        <div class="flex zhong">
                            <p style="width: calc(100% - 25px);cursor: pointer;" :class="{ 'red-text': scope.row.IsCollegesNames }" @click="xueTo(scope.row.CollegesName)">
                                {{ scope.row.CollegesName | shortName }}
                            </p>
                            <!-- <el-tooltip class="item" effect="dark" :content="scope.row.CollegesName" placement="bottom">
                                <img src="../../../image/shkl.png" style="width: 23px;height: 16px;margin-left: 0.5em;cursor: pointer;" />
                            </el-tooltip> -->
                            <div style="width: 23px;height: 16px;margin-left: 0.5em; position: relative;" class="hover">
                                <img src="../../../image/shkl.png" style="width: 23px;height: 16px;cursor: pointer;" />
                                <div class="hei">{{ scope.row.CollegesName }}</div>
                            </div>
                        </div>
                        <p>院校代码：{{ scope.row.CollegesCode }}</p>
                        <p>院校类别：{{ scope.row.CollegesType }}</p>
                        <p>院校类型：{{ scope.row.CollegesMold }}</p>
                        <p>特色：{{ scope.row.Characte }}</p>
                    </div>
                </template>
            </el-table-column>
            <el-table-column :label="columnName.CollegesAreaStr || '院校地区'" width="60">
                <template slot-scope="scope">
                    <span :class="{ 'red-text': scope.row.IsCollegesAreas }">{{ scope.row.CollegesArea }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="MajorCode" :label="columnName.MajorCodeStr || '专业代码'" width="60"></el-table-column>
            <el-table-column :label="columnName.MajorNameStr || '专业名称'" width="100">
                <template slot-scope="scope">
                    <div class="name_div ">
                        <div class="flex zhong" style="position: relative;">
                            <p style="width: calc(100% - 25px);cursor: pointer;" :class="{ 'red-text': scope.row.IsMajorNames }" @click="showMajorDetail(scope)">
                                {{ scope.row.MajorName | shortName }}
                            </p>
                            <!-- <el-tooltip
                                class="item"
                                effect="dark"
                                :content="scope.row.MajorName"
                                placement="bottom"
                            >

                            </el-tooltip> -->
                            <div style="width: 23px;height: 16px;margin-left: 0.5em; position: relative;" class="hover">
                                <img src="../../../image/shkl.png" style="width: 23px;height: 16px;cursor: pointer;" />
                                <div class="hei">{{ scope.row.MajorName }}</div>
                            </div>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column :label="columnName.EducationalStr || '学制/学费'" width="70">
                <template slot-scope="scope">
                    {{ `${scope.row.Educational || ''}/${scope.row.Tuition || ''}` }}
                </template>
            </el-table-column>
            <el-table-column :label="columnName.NewPlanStr || '计划'"><el-table-column prop="NewPlan" :label="columnName.Year || ''" width="52"></el-table-column></el-table-column>
            <el-table-column :label="columnName.YearsDateStr || '历年数据'">
                <el-table-column prop="yeara" :label="columnName.Year1 || `${currentYear - 1}`" width="100">
                    <template slot-scope="scope">
                        <div class="name_div " v-if="scope.row.Remarks != '新增'">
                            <p>计划：{{ scope.row.YearsDate1 ? scope.row.YearsDate1.NewPlan : '' }}</p>
                            <!-- <p>平均分：{{ scope.row.YearsDate1 ? scope.row.YearsDate1.Average : '' }}</p> -->
                            <p>最低分：{{ scope.row.YearsDate1 ? scope.row.YearsDate1.LowestScore : '' }}</p>
                            <p>最低位次：{{ scope.row.YearsDate1 ? scope.row.YearsDate1.LowestOrder : '' }}</p>
                        </div>
                        <div class="name_div " v-if="scope.row.Remarks == '新增'"><p>未招生</p></div>
                    </template>
                </el-table-column>
                <el-table-column prop="yearb" :label="columnName.Year2 || `${currentYear - 2}`" width="100">
                    <template slot-scope="scope">
                        <div class="name_div " v-if="scope.row.YearsDate2 && scope.row.YearsDate2.LowestScore">
                            <p>计划：{{ scope.row.YearsDate2 ? scope.row.YearsDate2.NewPlan : '' }}</p>
                            <!-- <p>平均分：{{ scope.row.YearsDate2 ? scope.row.YearsDate2.Average : '' }}</p> -->
                            <p>最低分：{{ scope.row.YearsDate2 ? scope.row.YearsDate2.LowestScore : '' }}</p>
                            <p>最低位次：{{ scope.row.YearsDate2 ? scope.row.YearsDate2.LowestOrder : '' }}</p>
                        </div>
                        <div class="name_div " v-if="(scope.row.YearsDate2 && !scope.row.YearsDate2.LowestScore) || !scope.row.YearsDate2"><p>未招生</p></div>
                    </template>
                </el-table-column>
                <el-table-column prop="yearc" :label="columnName.Year3 || `${currentYear - 3}`" width="100">
                    <template slot-scope="scope">
                        <div class="name_div " v-if="scope.row.YearsDate3 && scope.row.YearsDate3.LowestScore">
                            <p>计划：{{ scope.row.YearsDate3 ? scope.row.YearsDate3.NewPlan : '' }}</p>
                          <!--  <p>平均分：{{ scope.row.YearsDate3 ? scope.row.YearsDate3.Average : '' }}</p> -->
                            <p>最低分：{{ scope.row.YearsDate3 ? scope.row.YearsDate3.LowestScore : '' }}</p>
                            <p>最低位次：{{ scope.row.YearsDate3 ? scope.row.YearsDate3.LowestOrder : '' }}</p>
                        </div>
                        <div class="name_div " v-if="(scope.row.YearsDate3 && !scope.row.YearsDate3.LowestScore) || !scope.row.YearsDate3"><p>未招生</p></div>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column prop="AdmissionBatch" :label="columnName.BatchStr || '批次'" width="55"></el-table-column>
            <el-table-column prop="RequirementsSubjects" :label="columnName.RequirementsSubjectsStr || '选考科目'" width="55"></el-table-column>
            <el-table-column prop="Average"  :label="columnName.MajorGroupStr || '专业组'" width="55">
               
            </el-table-column>
            <!-- <el-table-column
                :label="columnName.UserAttentionStr || '关注'"
                width="55"
            >
                <template slot-scope="scope">
                    <img
                        :src="scope.row.UserAttention ? require('../../../image/gz_aa.png') : require('../../../image/gz_a.png')"
                        class="scImg"
                        style="zoom: 0.7;"
                        @click="attentItem(scope)"
                    />
                </template>
            </el-table-column> -->
            <el-table-column v-if="tableType === 1" label="操作" width="55">
                <template slot-scope="scope">
                    <div class="flex zhong center" style="flex-direction: column;padding-right: 5px;">
                        <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
const now = new Date();
import Sortable from 'sortablejs';
export default {
    props: {
        iszntb: {
            type: Boolean,
            default: true
        },
        tableType: {
            type: Number,
            default: 0
        },
        columnName: {
            type: Object,
            default: () => ({})
        },
		selectId: {
            type: Number,
            default: 0
        },
        list: {
            type: Array,
            default: () => []
        }
    },
    name: 'CollegeMajor',
    data() {
        return {
            currentYear: now.getFullYear(),
			originList:[]
        };
    },
    mounted() {
        console.log('iszntb', this.iszntb);
        this.list.map(a => {
            a.isPop = a.Remarks.includes('新增');
        });
		this.originList = this.$util.clone(this.list);
         this.setSort();
    },
    methods: {
         setSort() {
              const el = this.$refs.dragTable.$el.querySelectorAll(
                ".el-table__body-wrapper > table > tbody"
              )[0];
              this.sortable = new Sortable(el, {
                ghostClass: "blue-background-class", // Class name for the drop placeholder,// 抓取的元素的类名，简单来说就是抓取元素的时候给他加一个类名blue-background-class
                setData: function(dataTransfer) {
                  console.log("dataTransfer", dataTransfer);
                  dataTransfer.setData("Text", "");
                },
        
                onEnd: evt => {   // console 一下 evt ，你就明白下面为什么这样写
				  // console.log('index',evt.newIndex,evt.oldIndex);
				  
				  
				  if (evt.oldIndex !== evt.newIndex) {
					const targetRow = this.originList.splice(evt.oldIndex, 1)[0];
				  	this.originList.splice(evt.newIndex,0,targetRow);
				  	this.sortList();
				  }
                }
              });
            },
			// 排序后调用接口
			sortList() {
				this.$api.volunteerSetSort({
					Ids: this.originList.map(a => a.Id).join(','),
					SelectId: this.selectId
				}).then(res => {
					this.$alert('排序修改成功', '', {
						confirmButtonText: '确定'
					});
				});
			},
        // 删除志愿
        handleDelete(index, row) {
            this.$api
                .accurateDeleteVolunteer({
                    Id: row.Id
                })
                .then(res => {
                    this.$util.showOk('删除成功');
                    // this.getList();
                    this.list.splice(index, 1);
                });
        },
        // 跳转学校
        xueTo(name) {
            window.open(`${window.location.origin}${window.location.pathname}#/schoolinfo?schoolname=${name}`);
        },
        // 显示专业介绍
        showMajorDetail(scope) {
            this.$emit('showMajorDetail', scope);
        },
        // 跳转招生章程
        goSolution(url) {
            window.open(url);
        },
        // 关注
        attentItem(scope) {
            scope.row.UserAttention = !scope.row.UserAttention;
            this.$api
                .accurateAttentionAdd({
                    userId: this.$store.state.user.userId,
                    contentId: scope.row.Id,
                    type: 2
                })
                .then(() => {
                    this.$util.showOk(scope.row.UserAttention ? '关注成功' : '取消关注成功');
                })
                .catch(() => {
                    scope.row.UserAttention = !scope.row.UserAttention;
                });
        }
    }
};
</script>
<style lang="scss" scoped>
/deep/.el-table .cell {
    overflow: inherit;
}

.college-major {
    .red-text {
        color: red !important;
    }
}

.hei {
    background: #303133;
    color: #fff;
    border-radius: 4px;
    padding: 10px;
    z-index: 4;
    font-size: 12px;
    line-height: 1.2;
    min-width: 10px;
    word-wrap: break-word;
    position: absolute;
    left: -10px;
    top: 22px;
    z-index: 1;
    width: max-content;
    display: none;
}

.hei::after {
    content: '';
    width: 0;
    height: 0;
    border-right: 7px solid transparent;
    border-left: 7px solid transparent;
    border-bottom: 10px solid #303133;
    position: absolute;
    left: 14px;
    top: -7px;
    z-index: 1;
    margin: 0;
}

.hover:hover .hei {
    display: block;
}
</style>
